import axios from "axios";
import { store } from "../../../state-management/state-mgmt";
import Utility from "../../../shared/utility";
export default {
  getDashboardData(call, userId) {
    return this.getData(`/sh/shipping_bulk_queue_dashboard?user_key=${userId}`, call);
  },
  getShippingData(call, userId, pass) {
    return this.getData(`/sh/shipping_bulk_queue?user_key=${userId}&pass=${pass}`, call);
  },
  postShippingHeader(call, obj) {
    return this.getData(`sh/shipping_bulk_queue_lot_header`, call, obj);
  },
  postShippingDetailsMember(call, obj) {
    return this.getData(`sh/shipping_bulk_queue_member_list`, call, obj);
  },
  postTrackingNum(call, obj) {
    return this.getData(`sh/shipping_bulk_queue_SO_lpn_BULK`, call, obj, true);
  },
  getUploadedFiles(call, userId) {
    return this.getData(`/usb/parts_upload_getfiles?user_id=${userId}`, call);
  },
  getEventCodes(call) {
    return this.getData(`/usb/assettracking_get_event_codes`, call);
  },
  getAssetActions(call) {
    return this.getData(`/usb/assettracking_get_event_tracking_codes`, call);
  },
  assetTrackingSearch(call, obj, showMessage) {
    return this.getData(`usb/assettracking_search_results`, call, obj, showMessage);
  },
  getAssetTrackingHeaderInfo(call, UserID, main_key) {
    return this.getData(`/usb/assettracking_header_info?UserID=${UserID}&main_key=${main_key}`, call);
  },
  getAssetTrackingEventLog(call, UserID, main_key) {
    return this.getData(`/usb/assettracking_event_log?UserID=${UserID}&main_key=${main_key}`, call);
  },
  getAssetTrackingNotes(call, userid, main_key) {
    return this.getData(`/usb/assettracking_get_tech_notes?userid=${userid}&main_key=${main_key}`, call);
  },
  getEventDetailHeader(call, UserID, main_key) {
    return this.getData(`/usb/getDetailEventsHeader?UserID=${UserID}&main_key=${main_key}`, call);
  },
  eventDetailsInfo(call, obj, showMessage) {
    return this.getData(`usb/getDetailEventsInfo`, call, obj, showMessage);
  },
  getInboundDetailsService(call, userId, main_key) {
    return this.getData(`/usb/getInBoundLogEvents?UserID=${userId}&main_key=${main_key}`, call);
  },
  getOutboundDetailsService(call, userId, main_key) {
    return this.getData(`/usb/getOutBoundLogEvents?UserID=${userId}&main_key=${main_key}`, call);
  },
  assetTrackingEventRules(call, obj, showMessage) {
    return this.getData(`usb/assettracking_check_event_rules`, call, obj, showMessage);
  },
  assetTrackingEventSubmit(call, obj, showMessage) {
    return this.getData(`usb/assettracking_event_submit`, call, obj, showMessage);
  },
  assetTrackingEventPurge(call, obj, showMessage) {
    return this.getData(`usb/assettracking_purge`, call, obj, showMessage);
  },
  //USB Source for Configuration
  sourceCountryList(call, userId, queueType) {
    return this.getData(`/usb/sourcing_country?user_id=${userId}&queue_type=${queueType}`, call);
  },
  sourcingLPNStatus(call, userId) {
    return this.getData(`/usb/sourcing_lpn_status?user_id=${userId}`, call);
  },
  sourceMasterConfigQueueData(call, obj, showMessage) {
    return this.getData(`usb/sourcing_master_configuration_queue_data`, call, obj, showMessage);
  },
  sourceConfigHeaderData(call, obj, showMessage) {
    return this.getData(`usb/sourcing_configuration_header`, call, obj, showMessage);
  },
  getSourcingConfigRows(call, userId, soKey, workflowCode, lineId) {
    return this.getData(
      `/usb/sourcing_configuration_get_rows?user_key=${userId}&so_key=${soKey}&workflowcode=${workflowCode}&line_id=${lineId}`,
      call,
    );
  },
  sourceConfigPartsByRow(call, obj, showMessage) {
    return this.getData(`usb/sourcing_configuration_parts_by_row`, call, obj, showMessage);
  },
  sourceConfigPartsCheck(call, obj, showMessage) {
    return this.getData(`usb/sourcing_configuration_parts_check`, call, obj, showMessage);
  },
  //Configuration Sourcing
  sourceConfigLineKeys(call, userId, lpnKey) {
    return this.getData(`/usb/sourcing_configuration_line_keys?user_key=${userId}&lpn_key=${lpnKey}`, call);
  },
  //Repair
  repairGetHeaderByUnit(call, obj, showMessage) {
    return this.getData("wc/repair_get_header_by_unit", call, obj, showMessage);
  },
  getRepairBenchList(call, userId, mainKey) {
    return this.getData(`/wc/repair_bench_issue_list?user_id=${userId}&main_key=${mainKey}`, call);
  },
  repairGetBenchIssueParts(call, obj, showMessage) {
    return this.getData("wc/repair_bench_issue_get_parts", call, obj, showMessage);
  },
  getRepairReasons(call, obj, showMessage) {
    return this.getData("wc/repair_reasons_by_unit", call, obj, showMessage);
  },
  getRepairActionList(call, userId, mainKey) {
    return this.getData(`/wc/repair_actions_by_unit?User_id=${userId}&main_key=${mainKey}`, call);
  },
  getRepairFailCodeList(call, userId, mainKey) {
    return this.getData(`/wc/repair_get_failcodes_by_unit?User_id=${userId}&main_key=${mainKey}`, call);
  },
  repairBenchIssueIncrement(call, obj, showMessage) {
    return this.getData("wc/repair_bench_issue_increment", call, obj, showMessage);
  },
  repairBenchIssueReverse(call, obj, showMessage) {
    return this.getData("wc/repair_bench_issue_reverse", call, obj, showMessage);
  },
  //Initial test
  workcenterInitialTest(call, obj, showMessage) {
    return this.getData("wc/initial_test", call, obj, showMessage);
  },
  //Cosmetic Inspection
  workcenterCosmeticInspection(call, obj, showMessage) {
    return this.getData("wc/cosmetic_inspection", call, obj, showMessage);
  },
  workcenterBinLPNValidate(call, obj, showMessage) {
    return this.getData("wc/binlpn_validate", call, obj, showMessage);
  },
  //Engineering Evaluation
  engineeringEvaluation(call, obj, showMessage) {
    return this.getData("wc/engineering_evaluation", call, obj, showMessage);
  },
  getEnginEvalFaiLCodes(call, obj, showMessage) {
    return this.getData("wc/engineering_evaluation_failcodes", call, obj, showMessage);
  },
  getconfigSourcingDdl(call, UserID) {
    return this.getData(`wc/source_config_ddls?UserID=${UserID}`, call);
  },
  getMSRCheckList(call, mainKey) {
    return this.getData(`/wc/engi_eval_msr_checklist?main_key=${mainKey}`, call);
  },
  getEcoInfo(call, partKey) {
    return this.getData(`/wc/engi_eval_partviewer_eco?part_id=${partKey}`, call);
  },
  getTechComments(call, mainKey) {
    return this.getData(`/wc/engi_eval_get_techcomment?main_key=${mainKey}`, call);
  },
  getMainTechComments(call, mainKey) {
    return this.getData(`/wc/engi_eval_get_techcomment_main?main_key=${mainKey}`, call);
  },
  updateTechComments(call, obj, showMessage) {
    return this.getData("wc/engi_eval_insert_techcomment", call, obj, showMessage);
  },
  //Final Test
  workcenterFinalTest(call, obj, showMessage) {
    return this.getData("wc/final_test", call, obj, showMessage);
  },
  //Configuration Sourcing
  sourceConfigLoadOrder(call, userId, soKey) {
    return this.getData(`/wc/source_config_load_order?user_key=${userId}&so_key=${soKey}`, call);
  },
  sourceConfigFindbyPart(call, obj, showMessage) {
    return this.getData("wc/source_config_find_part", call, obj, showMessage);
  },
  exitConfigSourcing(call, userId, lineId) {
    return this.getData(`/wc/source_config_exit?user_id=${userId}&line_id=${lineId}`, call);
  },
  sourceConfigLoadSourcedLine(call, userId) {
    return this.getData(`/wc/source_config_load_sourcedline?user_key=${userId}`, call);
  },
  //Transit Order Logs
  getTransitOrderLogs(call, obj, showMessage) {
    return this.getData("usb/get_transit_order_logs", call, obj, showMessage);
  },

  async getData(url, call, obj, showMessage) {
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    let res = {};
    if (call == "get") {
      res = await axios.get(url).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    } else {
      res = await axios.post(url, obj).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    }
    if (res?.data?.body?.message != undefined || res?.data?.body?.message != null) {
      if (!res?.data?.body?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res?.data?.body?.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.body.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse(res?.data?.body?.message);
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    } else if (res?.data?.body?.message == null) {
      LoaderDialog.visible = false;
      store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      return JSON.parse('{"message":"NA"}');
    } else {
      if (!res?.data?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res.data.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse(res?.data?.message);
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    }
  },
};
